import { render, staticRenderFns } from "./add.vue?vue&type=template&id=9b5f5b46&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=9b5f5b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5f5b46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b5f5b46')) {
      api.createRecord('9b5f5b46', component.options)
    } else {
      api.reload('9b5f5b46', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=9b5f5b46&scoped=true&", function () {
      api.rerender('9b5f5b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/server/components/add.vue"
export default component.exports